import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function Layout() {
  return (
    <div className="ach-app">
      <Sidebar />
      <main className="ach-main">
        <div className="ach-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
